export default {
  logistics: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Entrepôt et logistique',
    hero: {
      eyebrow: 'Entrepôt et logistique',
      title: 'Surveillance de grandes surfaces pour la logistique et les entrepôts',
      lead: 'Grand-angle, PTZ et vision nocturne : nous couvrons de grands halls et extérieurs avec peu de caméras bien placées.',
    },
    areas: {
      title: "Zones de surveillance en entrepôt et logistique",
      lead: 'De l’entrée à l’emballage : nous structurons votre surveillance le long des flux de marchandises, sans lacunes.',
      items: {
        '0': { title: 'Entrée et sortie', desc: 'Chaque véhicule traversant votre site est capté, avec plaque et horodatage pour une documentation complète.' },
        '1': { title: 'Zone de livraison', desc: "L'arrivée et l'enlèvement des marchandises sont des moments sensibles. Les caméras documentent chaque geste à quai." },
        '2': { title: 'Rayonnages', desc: 'Les grands halls exigent de grandes solutions. Les caméras PTZ balayent les allées et zooment jusqu’à la palette.' },
        '3': { title: 'Préparation de commandes', desc: 'Emballage et préparation impliquent du mouvement. Les caméras de vue d’ensemble clarifient les réclamations.' },
        '4': { title: 'Extérieur et cour', desc: 'Le périmètre est la première ligne de défense. Des caméras résistantes surveillent clôtures, portails et véhicules.' },
        '5': { title: 'Bureau et administration', desc: 'La zone administrative a aussi besoin de protection : objets de valeur, documents et accès sensibles.' },
      },
    },
    coverage: {
      eyebrow: 'Grandes surfaces à l’œil',
      title: 'Une caméra, un grand effet',
      lead: 'Dans les entrepôts, c’est la vue d’ensemble qui compte. Plutôt que de nombreuses caméras, nous utilisons une technologie qui couvre intelligemment de grandes zones.',
      items: {
        '0': { title: 'Caméras PTZ', desc: 'Panoramique, inclinaison, zoom : une caméra couvre de grandes zones et fournit des détails au besoin.' },
        '1': { title: 'Vue grand-angle', desc: 'Pour sections de hall et extérieurs : des caméras grand-angle compactes capturent de grandes zones en une image.' },
        '2': { title: 'Vision jour et nuit', desc: 'Infrarouge et capteurs très sensibles fournissent des images exploitables même dans l’obscurité, 24 h/24.' },
      },
    },
    roundClock: {
      eyebrow: '24 heures sur 24',
      title: "Un enregistrement qui ne dort jamais",
      lead: 'Le trafic de marchandises ne s’arrête pas la nuit. Votre système enregistre 24 h/24 et rend les événements immédiatement retrouvables.',
      list: {
        '0': 'Enregistrement 24/7 sur enregistreur local avec durée définie',
        '1': "L'enregistrement sur événement économise le stockage et facilite la recherche",
        '2': 'Transfert d’alarme à des personnes définies en cas de mouvement en zone interdite',
        '3': 'Maintenance régulière par SSG Care pour une disponibilité durable',
        '4': 'Extensible avec des caméras supplémentaires et d’autres sites',
      },
      note: 'Remarque : la durée de conservation doit être adaptée aux exigences opérationnelles et éventuellement légales. Nous vous conseillons.',
    },
    cta: {
      title: 'Votre logistique, documentée sans lacune',
      lead: 'Nous analysons les flux de marchandises et les points à risque, et planifions un système adapté à votre structure.',
      primary: 'Prendre rendez-vous',
      secondary: 'Découvrir SSG Care',
    },
  },
};